import { Expose, Type } from 'class-transformer';
import { IParticipant, IParticipantMetadata } from '../interfaces/participant.interface';
import { BaseModel } from '@core/data-access';
import { Default } from '@core/util';

export class ParticipantMetadataModel extends BaseModel implements IParticipantMetadata {
  @Expose()
  @Default('')
  emailSubject!: string;

  @Expose()
  @Default(false)
  useCustomeSubject!: boolean;

  @Expose()
  @Default('')
  emailBody!: string;

  @Expose()
  @Default(false)
  useCustomeBody!: boolean;
  @Expose()
  contactId!: string;

  @Expose()
  requireOTP!: boolean;

  @Expose()
  requireForwarderOTP!: boolean;

  @Expose()
  refClientId!: number;

  @Expose()
  // @Type(() => DocumentESigningModel)
  // eSigning?: DocumentESigningModel;
  eSigning?: any;

  @Expose()
  forwardedBy?: {
    id: string;
    email: string;
    markupId: string;
    name: string;
  };
  @Expose()
  forwardFields?: string[];
}

export class ParticipantModel extends BaseModel implements IParticipant {
  @Expose()
  id!: number;
  @Expose()
  markupId!: string;
  @Expose()
  name!: string;
  // @Expose()
  // firstName: string;
  // @Expose()
  // lastName: string;
  @Expose()
  email!: string;

  @Expose()
  status!: string;
  @Expose()
  phone!: string;

  @Expose()
  @Default({
    emailSubject: '',
    emailBody: '',
  })
  @Type(() => ParticipantMetadataModel)
  metadata!: ParticipantMetadataModel;

  @Expose()
  @Default('signer')
  role!: string;

  @Expose()
  data!: string;

  @Expose()
  @Default(1)
  priority!: number;

  clientActionAt!: string;

  get empty(): boolean {
    return !!(this.name && this.email);
  }

  get defaultAvatar(): string {
    const strName = this.name.split(' ');
    let i = 0;
    let avatar = '';
    while (i < 2 && strName[i]) {
      avatar += strName[i][0];
      i++;
    }
    return avatar;
  }

  static toJsonForClone(data: ParticipantModel): any {
    return {
      markupId: data.markupId,
      metadata: {
        contactId: data.metadata?.contactId,
        refClientId: data.metadata?.refClientId,
        emailSubject: data.metadata?.emailSubject,
        useCustomeSubject: data.metadata?.useCustomeSubject,
        emailBody: data.metadata?.emailBody,
        useCustomeBody: data.metadata?.useCustomeBody,
        forwardedBy: data.metadata?.forwardedBy,
        forwardFields: data.metadata?.forwardFields,
      },
      name: data.name,
      email: data.email,
      role: data.role,
      priority: data.priority,
    };
  }
}
